export default __webpack_public_path__ + "assets/MyriadPro-CondIt.0298d776.svg";